import React from 'react';

import { IconProps } from './types';

/**
 * The connector between the Start and End rows of a date-range cell. Drawn
 * native at the island stroke weight rather than scaled from `DateArrowIcon`,
 * which is a filled shape and would read heavier beside the 1.75 icons it sits
 * between.
 */
export const CellDateArrowIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="20"
        viewBox="0 0 12 20"
        width="12"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M6 1.5V18.5"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
        <path
          d="M1.5 14L6 18.5L10.5 14"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
      </svg>
    );
  },
);
